/**
 * @file paddle hack topic
 * @author wanzhongyun
 */

import React from 'react';
// import { RightOutlined } from '@ant-design/icons';
import { RootObject } from '../../type';

import './style.less';


const HackTopic = (props: RootObject["hackathonBrowseTopic"]) => {

    const {
        titleImageUrl,
        topicList,
        // allTopicWord,
        // allTopicLink
    } = props;

    return (
        <div className='paddle-hack-topic-wrapper'>
            <div className='paddle-hack-topic-wrapper-content'>
                <div className='paddle-hack-topic-wrapper-content-header' style={{display: 'flex', justifyContent: 'center'}}>
                    <img className='paddle-hack-topic-title' src={titleImageUrl} alt='' />
                </div>
                <div className='paddle-hack-topic-card-wrapper'>
                    {
                        topicList.map(item => <div className='paddle-hack-topic-card' key={item.titleEn} onClick={() => { window.open(item.checkAllLink) }}>
                            <img className='paddle-hack-topic-card-icon' src={item.imageUrl} alt={item.titleZh} />
                            <div className='paddle-hack-topic-card-en-title'>{item.titleEn}</div>
                            <div className='paddle-hack-topic-card-zh-title'>{item.titleZh}</div>
                            <div className='paddle-hack-topic-desc'>{item.desc}</div>
                            <div className="paddle-hack-topic-check-all-wrapper">
                                <div className='paddle-hack-topic-check-all'>
                                    <span className='paddle-hack-topic-check-all-word'>{item.checkAll}</span>
                                    <span className='paddle-hack-topic-check-arrow' />
                                </div>
                            </div>
                        </div>)
                    }
                </div>

            </div>
        </div>
    );
};

export default HackTopic;